import { getDefaultSettings } from '../services/settingsService';
import { getBrandVatRate } from '../../shared/utils/brandCurrency';
import { SAUDI_SETTINGS_DEFAULTS } from '../../shared/config/saudiSettingsDefaults';

const REMOVED_INVOICE_TEMPLATE_IDS = new Set([
  'quantum', 'luxe', 'cube', 'precision', 'pulse', 'zenith', 'corporate',
]);

export function migrateRemovedInvoiceTemplates(design) {
  if (!design || typeof design !== 'object') return;
  const m = design.selectedModel;
  if (m == null || m === '' || REMOVED_INVOICE_TEMPLATE_IDS.has(String(m).toLowerCase())) {
    design.selectedModel = 'heritage';
  }
}

export function readCachedSettings() {
  try {
    const raw = localStorage.getItem('qawaem-settings');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}

export function cacheSettings(settings) {
  try {
    localStorage.setItem('qawaem-settings', JSON.stringify(settings));
  } catch {
    /* ignore quota errors */
  }
}

export function createInitialSettings(defaultConfiguration) {
  const base = readCachedSettings() || getDefaultSettings();
  return normalizeSettings(base, defaultConfiguration);
}

export function normalizeSettings(loadedSettings, defaultConfiguration) {
  const settings = { ...loadedSettings };
  const saudiDefaults = getDefaultSettings();

  if (!settings.company) settings.company = { ...saudiDefaults.company };
  if (!settings.company.rc) settings.company.rc = saudiDefaults.company.rc || '';
  if (!settings.company.rc2) settings.company.rc2 = '';
  if (!settings.company.activeRC) settings.company.activeRC = 'rc1';
  if (!settings.company.country) settings.company.country = saudiDefaults.company.country;
  if (!settings.company.currency && !settings.regional?.currency) {
    settings.regional = { ...(settings.regional || {}), ...saudiDefaults.regional };
  }

  if (!settings.design) {
    settings.design = { ...saudiDefaults.design };
  }
  migrateRemovedInvoiceTemplates(settings.design);

  const defaultVat = getBrandVatRate();

  if (!settings.taxes) {
    settings.taxes = { ...saudiDefaults.taxes };
  } else {
    if (settings.taxes.tva === undefined || settings.taxes.tva === 19) {
      settings.taxes.tva = defaultVat;
    }
    if (settings.taxes.remise === undefined) settings.taxes.remise = 0;
    if (settings.taxes.rabais === undefined) settings.taxes.rabais = 0;
    if (settings.taxes.escompte === undefined) settings.taxes.escompte = 0;
    if (settings.taxes.transportCost === undefined) settings.taxes.transportCost = 0;
    if (settings.taxes.returnCost === undefined) settings.taxes.returnCost = 0;
    if (settings.taxes.guarantee === undefined) settings.taxes.guarantee = 0;
    if (settings.taxes.avance === undefined) settings.taxes.avance = 0;
    if (settings.taxes.irg === undefined) settings.taxes.irg = 0;
    if (settings.taxes.ibs === undefined) settings.taxes.ibs = 0;
    if (settings.taxes.vatEnabled === undefined) settings.taxes.vatEnabled = true;
  }

  if (!settings.regional) {
    settings.regional = { ...saudiDefaults.regional };
  } else {
    settings.regional.locale = settings.regional.locale || SAUDI_SETTINGS_DEFAULTS.locale;
    settings.regional.currency = settings.regional.currency || SAUDI_SETTINGS_DEFAULTS.currency;
    settings.regional.language = settings.regional.language || SAUDI_SETTINGS_DEFAULTS.language;
  }

  if (!settings.notifications) {
    settings.notifications = { ...saudiDefaults.notifications };
  }

  if (!settings.configuration) {
    settings.configuration = defaultConfiguration;
  }

  if (!settings.invoicing) {
    settings.invoicing = {
      showReferenceColumn: true,
      defaultCurrency: SAUDI_SETTINGS_DEFAULTS.currency,
      documentLanguage: SAUDI_SETTINGS_DEFAULTS.language,
      documentCounters: {},
    };
  } else {
    if (settings.invoicing.showReferenceColumn === undefined) {
      settings.invoicing.showReferenceColumn = true;
    }
    if (!settings.invoicing.defaultCurrency) {
      settings.invoicing.defaultCurrency = SAUDI_SETTINGS_DEFAULTS.currency;
    }
  }

  return settings;
}
